export const appConfig = {
    baseAPIURL: process.env.VUE_APP_BaseAPIURL || 'https://api.dev.partssearch.com.au',
}
